import { createSlice } from '@reduxjs/toolkit';
import { requestStatusConstants } from '../../../Integration/integration-util';

const initialState = {
  poiCount: 0,
  status: requestStatusConstants.INITIAL,
};

const oohSlice = createSlice({
  name: 'ooh',
  initialState,
  reducers: {
    fetchPoiCountAction(state, action) {
      state.poiCount = initialState.poiCount;
      state.status = requestStatusConstants.PROGRESS;
    },
    fetchPoiCountSuccessAction(state, action) {
      state.poiCount = action.payload;
      state.status = requestStatusConstants.SUCCESS;
    },
    fetchPoiCountFailedAction(state, action) {
      state.poiCount = initialState.poiCount;
      state.status = requestStatusConstants.FAILED;
    },
    resetPoiCountAction(state, action) {
      state.poiCount = initialState.poiCount;
      state.status = initialState.status;
    },
  },
});

export const {
  fetchPoiCountAction,
  fetchPoiCountSuccessAction,
  fetchPoiCountFailedAction,
  resetPoiCountAction,
} = oohSlice.actions;
export default oohSlice.reducer;
